import styles from "./TopBarHeaderStart.module.scss"
import { TopBarHeaderStartProps } from "./TopBarHeaderStart.types"

export default function TopBarHeaderStart(props: TopBarHeaderStartProps) {
    const { children } = props

    return <div className={styles.base}>{children}</div>
}
